import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { CheckFilledIcon, ClockIcon } from 'transfix-icons'
import { Tooltip } from 'transfix-ui'

export const useApprovalIconStyles = makeStyles(theme => ({
  icon: {
    marginLeft: theme.spacing(1),
  },
}))

export interface IApprovalIconProps {
  isApproved: boolean
  /**
   * @default 'Pending Approval'
   */
  message?: string
  id: string
}

export const ApprovalIcon: FC<IApprovalIconProps> = React.memo(
  ({ id, isApproved, message = 'Pending Approval' }) => {
    const classes = useApprovalIconStyles()

    return isApproved ? (
      <CheckFilledIcon size='large' color='coolGray5' className={classes.icon} />
    ) : (
      <Tooltip
        position='bottom'
        id={id}
        trigger={
          <span>
            <ClockIcon size='large' color='warning' className={classes.icon} />
          </span>
        }>
        {message}
      </Tooltip>
    )
  }
)
